

import { Component, OnInit, Input } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { NzModalService } from 'ng-zorro-antd';
import { selectJump, selectSize, selectThemeSize, iconTheme } from "../../../data/data";

@Component({
    selector: 'app-sucu05-button0020001',
    templateUrl: './sucu05-button0020001.component.html',
})
export class Sucu05Button0020001Component implements OnInit {
    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() sets = {
        blockId: "",
        layoutId: "",
        blockType: 'formButton',
        blockChildType: '',
        versionCode: 1,
        styles: {
            nzText: "新增",
            nzType: "default",
            nzSize: "default",
            nzBgColor: "",
            nzIcon: {
                nzIconType: '',
                nzIconTheme: '',
                nzIconColor: '',
            },

        },
        datas: {
            nzDataSource: "",
            nzJumpType: "pop",
            nzJumpPage: ""

        }
    };
    setData = [
        {
            tabName: '数据',
            datas: [
                {
                    type: 'datas',
                    data: [
                        { name: 'nzDataSource', }
                    ]
                }
            ]
        },
        {
            tabName: '操作',
            datas: [

                {
                    type: 'datas',
                    data: [
                        {
                            name: 'select',
                            inputs: {
                                nzText: "跳转方式 : ", nzKeys: ['datas', 'nzJumpType'], nzData: selectJump
                            }
                        },
                        { name: 'nzJumpPage', }
                    ]
                },
            ]
        },
        {
            tabName: '样式',
            datas: [
                {
                    type: 'styles',
                    data: [
                        {
                            name: 'input',
                            inputs: {
                                nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                            }
                        },
                        {

                            name: 'select',
                            inputs: {
                                nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                            }
                        },

                        {
                            name: 'color',
                            inputs: {
                                nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                            }
                        },
                        {
                            name: 'radio',
                            inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
                        },
                    ]
                },
            ]
        }
    ]


    constructor(
        public setService: SetService,
        private modalService: NzModalService,

    ) { }
    ngOnInit() {
        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }
                

            }
            else {//静态
                if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
            }
        }
    }
    onClick() {

    }

}

